// extracted by mini-css-extract-plugin
export var active = "navigation-module--active--08cb2";
export var col = "navigation-module--col--f70d2";
export var collapsed = "navigation-module--collapsed--cd50b";
export var container = "navigation-module--container--b38a2";
export var dropdownItem = "navigation-module--dropdownItem--c1422";
export var dropdownMenu = "navigation-module--dropdownMenu--b1b10";
export var link = "navigation-module--link--8919e";
export var linkWrapper = "navigation-module--linkWrapper--ba7d4";
export var logoWrapper = "navigation-module--logoWrapper--65cd3";
export var main = "navigation-module--main--91c48";
export var menu = "navigation-module--menu--93de3";
export var small = "navigation-module--small--ad303";
export var util = "navigation-module--util--79a5e";